<template>
  <div class="progress-out">
    <div class="progress-in" :style="{width: progress + '%'}"></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: Number
  },
  data () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.progress-out {
  height: 10px;
  width: 100%;
  border-radius: 10px;
  border: 2px solid #fff;
  background: #aad8dc;
}
.progress-in {
  width: 0;
  height: 10px;
  border-radius: 10px;
  background-color: #008392;
}
</style>
